export default __webpack_public_path__ + "static/media/ranking-gain-exp-step0.279522d6.png";